import { AbstractAdapter } from './AbstractAdapter'
import { getWaleltProvider, SupportProviderFlag } from '../provider';
import type { SolanaProvider } from '../provider';

type SolanaAdapterOptions = {
  isBitkeep?: boolean | undefined;
  debug?: boolean
};

class SolanaAdapter extends AbstractAdapter {
  constructor(Options: SolanaAdapterOptions = {
    isBitkeep: true,
    debug: false
  }) {
    super({
      providerFlag: SupportProviderFlag.SOLANA,
      isBitkeep: Options.isBitkeep,
      debug: Options.debug
    });
  }
  getProvider() {
    return getWaleltProvider<SolanaProvider>(this.providerFlag) as SolanaProvider;
  }
}

export { SolanaAdapter };
